// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Stdlib_List from "@rescript/runtime/lib/es6/Stdlib_List.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.jsx";

function joinPath(path) {
  return "/" + Stdlib_List.toArray(path).join("/");
}

function resolveRelativePath(pathname) {
  if (!pathname.startsWith(".")) {
    return pathname;
  }
  let pathnameSegments = Stdlib_Array.reduceRight(pathname.split("/"), {
    subtract: 0,
    segments: /* [] */0
  }, (param, segment) => {
    let segments = param.segments;
    let subtract = param.subtract;
    switch (segment) {
      case "" :
      case "." :
        return {
          subtract: subtract,
          segments: segments
        };
      case ".." :
        return {
          subtract: subtract + 1 | 0,
          segments: segments
        };
      default:
        return {
          subtract: subtract,
          segments: Stdlib_List.add(segments, segment)
        };
    }
  });
  let currentPath = RescriptReactRouter.dangerouslyGetInitialUrl(undefined, undefined).path;
  let pathPrefix = Stdlib_List.take(currentPath, Stdlib_List.length(currentPath) - pathnameSegments.subtract | 0);
  return joinPath(pathPrefix !== undefined ? Stdlib_List.concat(pathPrefix, pathnameSegments.segments) : pathnameSegments.segments);
}

function handleLinkClick(handler) {
  return event => {
    if (event.isDefaultPrevented() || event.button !== 0 || event.metaKey || event.altKey || event.ctrlKey || event.shiftKey) {
      return;
    } else {
      event.preventDefault();
      return handler();
    }
  };
}

function createLinkClickHandler(replaceOpt, pathname) {
  let replace = replaceOpt !== undefined ? replaceOpt : false;
  return handleLinkClick(() => {
    if (replace) {
      return RescriptReactRouter.replace(pathname);
    } else {
      return RescriptReactRouter.push(pathname);
    }
  });
}

function createAnchorProps(replaceOpt, pathname) {
  let replace = replaceOpt !== undefined ? replaceOpt : false;
  let resolvedPath = resolveRelativePath(pathname);
  return {
    href: resolvedPath,
    onClick: createLinkClickHandler(replace, resolvedPath)
  };
}

function createShareLink(shareLinkId) {
  let origin = window.location.origin;
  return origin + `/s/` + shareLinkId;
}

let fromHomepageHash = "from_homepage";

function isFromHomepage(url) {
  return url.hash === fromHomepageHash;
}

export {
  joinPath,
  resolveRelativePath,
  handleLinkClick,
  createLinkClickHandler,
  createAnchorProps,
  createShareLink,
  fromHomepageHash,
  isFromHomepage,
}
/* RescriptReactRouter Not a pure module */
